import React from "react";

import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import { Button, Popover, TextField } from "@mui/material";
import { StaticDateTimePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
import { Controller, useForm } from "react-hook-form";
import { makeStyles } from "tss-react/mui";

import usePopupState from "@/hooks/usePopupState";
import { muiDate } from "@/utils/hookForm";

interface Props {
  defaultValues?: RemarkValues;
  onCancel: () => void;
  onSubmit: (values: RemarkValues) => void;
}

export interface RemarkValues {
  comment: string;
  createdAt: Date;
}

const useStyles = makeStyles()({
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 8,
  },
  calendarButton: {
    fontSize: 12,
    "& .MuiButton-startIcon svg": {
      fontSize: 12,
    },
  },
  saveButton: {
    marginLeft: 8,
  },
});

const RemarkForm: React.FC<Props> = ({ defaultValues, onCancel, onSubmit }) => {
  const { classes } = useStyles();
  const calendarPicker = usePopupState();
  const {
    register,
    watch,
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: defaultValues ?? {
      comment: "",
      createdAt: new Date(),
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        {...register("comment")}
        size="small"
        placeholder="Add remarks here"
        multiline
        fullWidth
        InputProps={{
          autoFocus: true,
        }}
      />
      <div className={classes.footer}>
        <Button
          className={classes.calendarButton}
          variant="text"
          color="inherit"
          startIcon={<EditCalendarOutlinedIcon />}
          onClick={calendarPicker.show}
        >
          {format(watch("createdAt"), "MMM d, yyyy, p")}
        </Button>
        <Popover {...calendarPicker.props}>
          <Controller
            control={control}
            name="createdAt"
            render={({ field }) => (
              <StaticDateTimePicker
                {...muiDate(field)}
                onClose={calendarPicker.hide}
              />
            )}
          />
        </Popover>
        <div>
          <Button variant="outlined" size="small" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            className={classes.saveButton}
            type="submit"
            size="small"
            disabled={isSubmitting}
          >
            Save Remark
          </Button>
        </div>
      </div>
    </form>
  );
};

export default RemarkForm;
